import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var DataService = /** @class */ (function () {
    function DataService() {
        this.defaultMessageConstant = 'default message';
        this.messageSource = new BehaviorSubject(this.defaultMessageConstant);
        this.membershipSource = new BehaviorSubject(this.defaultMessageConstant);
        this.userRoleSource = new BehaviorSubject(this.defaultMessageConstant);
        this.bpgListSource = new BehaviorSubject(this.defaultMessageConstant);
        this.eventsViewDetailsSource = new BehaviorSubject(this.defaultMessageConstant);
        this.expenseEditDataSource = new BehaviorSubject(null);
        this.navigationBpgListSource = new BehaviorSubject(this.defaultMessageConstant);
        this.claimExpense = new BehaviorSubject(null);
        this.siteIdAndPathSource = new BehaviorSubject(this.defaultMessageConstant);
        this.eventDateSource = new BehaviorSubject('null');
        this.selectedEventDataSourceSource = new BehaviorSubject('null');
        this.messageApproveSource = new BehaviorSubject(this.defaultMessageConstant);
        this.budgetDateSource = new BehaviorSubject(null);
        this.selectedMyBpgsDataSource = new BehaviorSubject(this.defaultMessageConstant);
        this.selectedSiteIdSource = new BehaviorSubject(this.defaultMessageConstant);
        this.selectedSiteIdForSiteMenuSource = new BehaviorSubject(this.defaultMessageConstant);
        this.selectedNaacIdForNaacMenuSource = new BehaviorSubject(this.defaultMessageConstant);
        this.folderSectionSource = new BehaviorSubject('null');
        this.isEventPopupOpenedSource = new BehaviorSubject(null);
        this.setBannerSource = new BehaviorSubject(null);
        this.openSiteChangePopup = new BehaviorSubject(null);
        this.userDetails = new BehaviorSubject(null);
        this.savedMembershipForm = this.membershipSource.asObservable();
        this.savedData = this.messageSource.asObservable();
        this.userRoleData = this.userRoleSource.asObservable();
        this.bpgListData = this.bpgListSource.asObservable();
        this.selectedEventsDetails = this.eventsViewDetailsSource.asObservable();
        this.selectedBpgList = this.navigationBpgListSource.asObservable();
        this.expenseEditData = this.expenseEditDataSource.asObservable();
        this.claimExpenseData = this.claimExpense.asObservable();
        this.siteIdAndPath = this.siteIdAndPathSource.asObservable();
        this.eventDate = this.eventDateSource.asObservable();
        this.eventViewApprove = this.messageApproveSource.asObservable();
        this.claimExpenseApprove = this.messageApproveSource.asObservable();
        this.eventData = this.selectedEventDataSourceSource.asObservable();
        this.budgetData = this.budgetDateSource.asObservable();
        this.myBpgsData = this.selectedMyBpgsDataSource.asObservable();
        this.selectedSiteId = this.selectedSiteIdSource.asObservable();
        this.selectedSiteIdForSiteNavMenu = this.selectedSiteIdForSiteMenuSource.asObservable();
        this.selectedNaacIdForNaacMenu = this.selectedNaacIdForNaacMenuSource.asObservable();
        this.folderSection = this.folderSectionSource.asObservable();
        this.isEventPopupOpened = this.isEventPopupOpenedSource.asObservable();
        this.isBanner = this.setBannerSource.asObservable();
        this.siteEffectedPopup = this.openSiteChangePopup.asObservable();
        this.userData = this.userDetails.asObservable();
    }
    DataService.prototype.saveData = function (message) {
        this.messageSource.next(message);
    };
    DataService.prototype.userRoleDetails = function (message) {
        this.userRoleSource.next(message);
    };
    DataService.prototype.bpgList = function (message) {
        this.bpgListSource.next(message);
    };
    DataService.prototype.showSavedMembershipForm = function (message) {
        this.membershipSource.next(message);
    };
    DataService.prototype.getSelectedEventDetails = function (message) {
        this.eventsViewDetailsSource.next(message);
    };
    DataService.prototype.selectedNavigationBpgs = function (message) {
        this.navigationBpgListSource.next(message);
    };
    DataService.prototype.selectedSiteIdAndPath = function (message) {
        this.siteIdAndPathSource.next(message);
    };
    // selectedSiteIdBpgIdAndPath(message: any) {
    //   this.siteIdBpgIdAndPathSource.next(message);
    // }
    DataService.prototype.setSelectedEventDate = function (message) {
        this.eventDateSource.next(message);
    };
    DataService.prototype.setselectedEventInfo = function (message) {
        this.selectedEventDataSourceSource.next(message);
    };
    // selectedSiteIdBpgIdAndPath(message:any){
    //   this.siteIdBpgIdAndPathSource.next(message);
    // }
    DataService.prototype.saveClaimData = function (data) {
        this.claimExpense.next(data);
    };
    DataService.prototype.setApproved = function (message) {
        this.messageApproveSource.next(message);
    };
    DataService.prototype.setEditExpenceData = function (message) {
        this.expenseEditDataSource.next(message);
    };
    DataService.prototype.saveBudget = function (message) {
        this.budgetDateSource.next(message);
    };
    DataService.prototype.setMyBpgSiteIdAndBpgId = function (message) {
        this.selectedMyBpgsDataSource.next(message);
    };
    DataService.prototype.setSiteId = function (message) {
        this.selectedSiteIdSource.next(message);
    };
    DataService.prototype.selectedSiteIdForSiteMenu = function (message) {
        this.selectedSiteIdForSiteMenuSource.next(message);
    };
    DataService.prototype.selectednaacIdForNaacMenu = function (message) {
        this.selectedNaacIdForNaacMenuSource.next(message);
    };
    DataService.prototype.folderSections = function (message) {
        this.folderSectionSource.next(message);
    };
    DataService.prototype.setEventPopupOpened = function (message) {
        this.isEventPopupOpenedSource.next(message);
    };
    DataService.prototype.setBanner = function (message) {
        this.setBannerSource.next(message);
    };
    DataService.prototype.siteAffectedPopup = function (message) {
        this.openSiteChangePopup.next(message);
    };
    DataService.prototype.setUserDetails = function (message) {
        this.userDetails.next(message);
    };
    DataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(); }, token: DataService, providedIn: "root" });
    return DataService;
}());
export { DataService };
var Bpgs = /** @class */ (function () {
    function Bpgs() {
    }
    return Bpgs;
}());
export { Bpgs };
var Interests = /** @class */ (function () {
    function Interests() {
    }
    return Interests;
}());
export { Interests };
var Skills = /** @class */ (function () {
    function Skills() {
    }
    return Skills;
}());
export { Skills };
var Leadership = /** @class */ (function () {
    function Leadership() {
    }
    return Leadership;
}());
export { Leadership };
var Demographics = /** @class */ (function () {
    function Demographics() {
    }
    return Demographics;
}());
export { Demographics };
var Site = /** @class */ (function () {
    function Site() {
    }
    return Site;
}());
export { Site };
var MembershipFormData = /** @class */ (function () {
    function MembershipFormData() {
    }
    return MembershipFormData;
}());
export { MembershipFormData };
var MembershipDetails = /** @class */ (function () {
    function MembershipDetails() {
        this.bpgIds = [];
        this.skillIds = [];
        this.areaOfImpactIds = [];
        this.demographicIds = [];
    }
    return MembershipDetails;
}());
export { MembershipDetails };
var MembershipData = /** @class */ (function () {
    function MembershipData() {
        this.bpgIds = [];
        this.skillIds = [];
        this.areaOfImpactIds = [];
        this.demographicIds = [];
    }
    return MembershipData;
}());
export { MembershipData };
var LandingDTOModel = /** @class */ (function () {
    function LandingDTOModel() {
        this.page = 0;
        this.presentRole = '-';
        this.searchTerm = '';
        this.size = 0;
        this.sortDirection = 'ASC';
        this.sortProperty = '-';
        this.uid = '-';
    }
    return LandingDTOModel;
}());
export { LandingDTOModel };
var FilterModel = /** @class */ (function () {
    function FilterModel() {
    }
    return FilterModel;
}());
export { FilterModel };
var Budget = /** @class */ (function () {
    function Budget() {
        this.affinityGoals = "";
        this.chapterGoals = "";
        this.chapterName = "";
        this.siteName = "";
        this.budgetStatus = "";
        this.budgetAllocatedDate = null;
        this.budgetAllocatedBy = "";
        this.comment = "";
        this.budgetSource = "";
        this.budgetRequestedDate = null;
    }
    return Budget;
}());
export { Budget };
var Amount = /** @class */ (function () {
    function Amount() {
    }
    return Amount;
}());
export { Amount };
var Hoshin = /** @class */ (function () {
    function Hoshin() {
        this.bpgInitiative = "";
        this.businessDrivers = "";
        this.actionPlan = "";
        this.kpi = "";
        this.estimatedTiming = "";
        this.midYearResults = "";
        this.yearEndResults = "";
        this.challenges = "";
        this.supportingDoc1 = "";
        this.leadAdminApprovalComment = "";
        this.superAdminApprovalComment = "";
        this.hoshinSubmitDate = null;
        this.leadAdminApprovedDate = null;
        this.superAdminApprovedDate = null;
        this.name = "";
        this.budgetType = "";
        this.createdBy = "";
        this.modifiedBy = "";
        this.status = "";
        this.frequency = "";
        this.lead1Name = "";
        this.lead2Name = "";
        this.baseHoshinExists = "";
        this.additionalFunding = "";
        this.additionalFundingSource = "";
        this.evaluation = "";
    }
    return Hoshin;
}());
export { Hoshin };
var BudgetHoshin = /** @class */ (function () {
    function BudgetHoshin() {
    }
    return BudgetHoshin;
}());
export { BudgetHoshin };
/* Survey Response */
var Employee = /** @class */ (function () {
    function Employee() {
    }
    return Employee;
}());
export { Employee };
var SurveyQuestion = /** @class */ (function () {
    function SurveyQuestion() {
    }
    return SurveyQuestion;
}());
export { SurveyQuestion };
var SurveyAnswer = /** @class */ (function () {
    function SurveyAnswer() {
    }
    return SurveyAnswer;
}());
export { SurveyAnswer };
var TakeSurvey = /** @class */ (function () {
    function TakeSurvey() {
        this.comments = "";
        this.modifiedBy = "";
        this.createdBy = "";
        this.surveyTakenUserName = "";
    }
    return TakeSurvey;
}());
export { TakeSurvey };
var SurveyMaster = /** @class */ (function () {
    function SurveyMaster() {
        this.surveryDesc = "";
        this.startDate = new Date();
        this.endDate = new Date();
    }
    return SurveyMaster;
}());
export { SurveyMaster };
var SitePrimaryContactDTO = /** @class */ (function () {
    function SitePrimaryContactDTO() {
        this.createdBy = "";
        this.createdDateTime = null;
        this.sitePrimaryContactId = null;
    }
    return SitePrimaryContactDTO;
}());
export { SitePrimaryContactDTO };
var SuveyTakenByUserDTO = /** @class */ (function () {
    function SuveyTakenByUserDTO() {
    }
    return SuveyTakenByUserDTO;
}());
export { SuveyTakenByUserDTO };
/*Pagination DTO */
var LandingPaginationDTO = /** @class */ (function () {
    function LandingPaginationDTO() {
        this.moduleId = 0;
        this.page = 0;
        this.presentRole = '';
        this.searchTerm = '';
        this.size = 0;
        this.sortDirection = '';
        this.sortProperty = '';
        this.uid = '';
    }
    return LandingPaginationDTO;
}());
export { LandingPaginationDTO };
